export const SUB_TEXT = 'sub-text'
export const HELP_TEXT = 'help-text'
export const STATE_TEXT = 'state-text'
